import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "Do I need a medical exam to qualify?",
    a: "No. Most of the plans we shop are no-exam plans. We have guaranteed-issue policies (no health questions at all) and simplified-issue plans (just a few yes/no questions over the phone). We'll match you to whatever fits your situation.",
  },
  {
    q: "Can I really afford this on a fixed income?",
    a: "Yes. Plans through our partner carriers start as low as $9.95/month. Because we shop 30+ carriers in a single call, we find the absolute lowest rate for your age, gender, and coverage amount — often saving seniors 30–60% versus a single-carrier quote.",
  },
  {
    q: "Am I too old to get covered?",
    a: "Probably not. We work with carriers that accept applicants up to age 85 (and a few up to age 89). Guaranteed-issue policies are available regardless of health history.",
  },
  {
    q: "How fast can my coverage start?",
    a: "Many seniors are approved during the phone call itself. Coverage can begin the same day you sign up for guaranteed-issue plans, or within 24–48 hours for most simplified-issue plans.",
  },
  {
    q: "Will my premium go up later?",
    a: "Not on whole life and final expense plans we offer — your monthly premium is locked in for life. Term plans have level premiums for the term length you choose (10, 15, 20, or 30 years).",
  },
  {
    q: "Is this Medicare or government-affiliated?",
    a: "No. Affordable Life Coverage is a private licensed insurance agency. We are not affiliated with Medicare, the Social Security Administration, or any federal government agency. We help you compare private life insurance plans.",
  },
  {
    q: "What happens after I call?",
    a: "A licensed agent answers, asks a few simple questions (age, ZIP code, coverage goal), then quotes you live from 30+ carriers. No obligation. If you like a quote, we can complete the application by phone — usually in under 15 minutes.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-16 md:py-24 bg-white"
    >
      <div className="mx-auto max-w-4xl px-6 md:px-12">
        <p className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-green-700 text-center">
          Common Questions
        </p>
        <h2
          data-testid="faq-heading"
          className="font-serif-display mt-3 text-3xl md:text-5xl font-bold leading-tight tracking-tight text-blue-900 text-center"
        >
          Answers from real licensed agents.
        </h2>
        <p className="mt-5 text-xl text-slate-700 leading-relaxed text-center max-w-2xl mx-auto">
          Still have questions? Call us — we&apos;ll walk you through everything in
          plain English.
        </p>

        <Accordion
          type="single"
          collapsible
          className="mt-10 md:mt-12 space-y-4"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="bg-white border-2 border-slate-200 rounded-2xl px-6 md:px-7 data-[state=open]:border-blue-300 data-[state=open]:bg-blue-50/40 transition-colors"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${idx}`}
                className="py-6 text-left text-lg md:text-xl font-bold text-slate-900 hover:no-underline [&[data-state=open]>svg]:text-blue-900"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${idx}`}
                className="pb-6 text-lg leading-relaxed text-slate-700"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
